import React from 'react';

function PageCard({ title, description, children }) {
  return (
    <section className="page-card">
      <div className="card-heading">
        <h2>{title}</h2>
        {description && <p>{description}</p>}
      </div>
      {children}
    </section>
  );
}

export default PageCard;